import { getRandomNumbers } from '../Utility/Numbers.js';

export default {
    methods: {
        getRandomFeaturedFactChecks (numToGrab, fcs){
            
            var numbers = getRandomNumbers(numToGrab, fcs.length);
            
            var random = [];
        
            for (var i = 0; i < numbers.length; i++) {

                var index = numbers[i] - 1;
        
                if( fcs[index] ){
                    random.push(fcs[index]);
                }
            
            }

            return random;
        },
    },
};